import React from 'react';
import FormCreateLycee from './FormCreateLycee';
import { setLyceeForm } from '../../../../../store/actions';
import { ButtonWithText } from '../../../../atoms/Buttons/ButtonWithText';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../../../../store/reducers';
import { lyceeFormErrorHandling } from '../../../../../helpers/forms/formsErrorHandling/lyceeFormErrorHandling';

interface CreateLyceeProps {
  step: number;
  setStep: (step) => void;
}

const CreateLycee = ({ step, setStep }: CreateLyceeProps) => {
  const lycee = useSelector((state: AppState) => state.createLycee);
  const dispatch = useDispatch();
  const handleChange = e => {
    dispatch(
      setLyceeForm(lyceeFormErrorHandling(lycee, e.target.name, e.target.value))
    );
  };

  return (
    <>
      <FormCreateLycee lycee={lycee} handleChange={handleChange} />
      <div style={{ float: 'right' }}>
        <ButtonWithText
          content={'Suivant'}
          onClick={() => setStep(step + 1)}
          icon={'RightArrow'}
          disabled={!lycee.isValid}
          iconColor={'white'}
          variant={'primaryBlue'}
        />
      </div>
    </>
  );
};

export default CreateLycee;
